import { render, staticRenderFns } from "./emptyPage.vue?vue&type=template&id=2312d63b&scoped=true"
import script from "./emptyPage.vue?vue&type=script&lang=ts"
export * from "./emptyPage.vue?vue&type=script&lang=ts"
import style0 from "./emptyPage.vue?vue&type=style&index=0&id=2312d63b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2312d63b",
  null
  
)

export default component.exports